import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { NgxScrollTopModule } from "ngx-scrolltop";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { FooterComponent } from "./components/layouts/footer/footer.component";
import { Navbar } from "./components/layouts/navbar/navbar.component";
import { PreloaderComponent } from "./components/layouts/preloader/preloader.component";
import { HomeComponent } from "./components/pages/home/home.component";
import { UnderConstructionComponent } from "./components/pages/under-construction/under-construction.component";
import { HttpClientModule } from "@angular/common/http";
import { EmitterService } from "./EmitterService";
import { SafePipe } from "../app/utils/safe.pipe";
import { NameGhangePipe } from "./namechange.pipe";
import { TemplatePageComponent } from "./components/pages/template-page/template-page.component";
import { LayoutDocumentListComponent } from "./components/layouts/layout-document-list/layout-document-list.component";
import { LayoutDocumentSingleComponent } from "./components/layouts/layout-document-single/layout-document-single.component";
import { LayoutImageListComponent } from "./components/layouts/layout-image-list/layout-image-list.component";
import { LayoutImageMultipleComponent } from "./components/layouts/layout-image-multiple/layout-image-multiple.component";
import { LayoutImageSingleComponent } from "./components/layouts/layout-image-single/layout-image-single.component";
import { NotFoundComponent } from "./components/pages/not-found/not-found.component";
import { ContactComponent } from "./components/pages/contact/contact.component";
import { ImageGalleryComponent } from "./components/pages/image-gallery/image-gallery.component";
import { ImageFolderComponent } from "./components/pages/image-folder/image-folder.component";
import { VideoGalleryComponent } from "./components/pages/video-gallery/video-gallery.component";
import { VideoFolderComponent } from "./components/pages/video-folder/video-folder.component";
import { AdministrationComponent } from "./components/pages/administration/administration.component";
import { NoticeComponent } from "./components/pages/notice/notice.component";
import { AppService } from "./app.service";
import { NewAndEventsComponent } from "./components/pages/new-and-events/new-and-events.component";
import { NewAndEventsItemsComponent } from "./components/pages/new-and-events-items/new-and-events-items.component";
import { AchievementsComponent } from "./components/pages/achievements/achievements.component";
import { AchievementsItemComponent } from "./components/pages/achievements-item/achievements-item.component";
import { AsideComponent } from "./components/layouts/aside/aside.component";
import { GbAsideComponent } from "./components/pages/gb-aside/gb-aside.component";
import { ModalComponent } from "./components/layouts/modal/modal.component";
import { OtherNoticesComponent } from './components/pages/other-notices/other-notices.component';

// import { AboutComponent } from './about/about.component';
@NgModule({
  declarations: [
    AppComponent,
    PreloaderComponent,
    FooterComponent,
    HomeComponent,
    Navbar,
    UnderConstructionComponent,
    NameGhangePipe,
    SafePipe,
    TemplatePageComponent,
    LayoutDocumentListComponent,
    LayoutDocumentSingleComponent,
    LayoutImageListComponent,
    LayoutImageMultipleComponent,
    LayoutImageSingleComponent,
    NotFoundComponent,
    ContactComponent,
    ImageGalleryComponent,
    ImageFolderComponent,
    VideoGalleryComponent,
    VideoFolderComponent,
    AdministrationComponent,
    NoticeComponent,
    NewAndEventsComponent,
    NewAndEventsItemsComponent,
    AchievementsComponent,
    AchievementsItemComponent,
    AsideComponent,
    GbAsideComponent,
    ModalComponent,
    OtherNoticesComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgxScrollTopModule,
    HttpClientModule,
  ],
  providers: [AppService, EmitterService],
  bootstrap: [AppComponent],
})
export class AppModule {}
